import React from 'react'
import { cn } from '@/lib/utils'

type ContactAddressProps = {
	address?: string
	googleMapsLink?: string
	theme?: 'light' | 'dark'
	className?: string
}

const ContactAddress = ({ address, googleMapsLink, theme, className }: ContactAddressProps) => {
	if (!address) return null
	const addressSanitized = address.replace(/<[^>]*>/g, '') // Remove any HTML tags
	const addressFormatted = addressSanitized.replace(/\n/g, '<br />')
	return (
		<div className={cn('', className)}>
			<h3>Address</h3>

			<p>
				{googleMapsLink ? (
					<a
						href={googleMapsLink}
						className={cn('hover:text-blue transition', theme === 'dark' ? 'text-white' : 'text-black')}
						target="_blank"
						rel="noopener noreferrer">
						<span dangerouslySetInnerHTML={{ __html: addressFormatted }} />
					</a>
				) : (
					<span dangerouslySetInnerHTML={{ __html: addressFormatted }} />
				)}
			</p>
		</div>
	)
}

export default ContactAddress
